import React, { useCallback } from 'react';
import {
  HeaderIcon,
  NaviIconHome,
  NaviIconSearch,
  StackScreen,
  useStatusBarUpdate,
} from '@banhala/ui-kit';
import { useHandleBackPressed } from 'shared/src/hooks';
import { CartIcon } from 'shared/src/component';
import { useNavigator } from 'shared/src/utils';
import { GoodsDetailContents } from './components/GoodsDetailContents';
import { useSetScreenName } from 'shared/src/hooks';
import { useLogClickHome } from './hooks/useLogClickHome';
import { useLogClickSearch } from './hooks/useLogClickSearch';
import { useLogClickCart } from './hooks/useLogClickCart';
import { useAffiliateAccessLog } from './hooks/useAffiliateAccessLog';
import { BottomDockedHeightProvider } from 'shared/src/hooks/useBottomDockedHeight';

const GoodsDetailPage: React.FC = () => {
  const { navigator } = useNavigator();
  const { onPressBack, showBackButton } = useHandleBackPressed();

  useSetScreenName('GOODS_DETAIL');
  useAffiliateAccessLog();
  const logClickHome = useLogClickHome();
  const logClickSearch = useLogClickSearch();
  const logClickCart = useLogClickCart();

  useStatusBarUpdate('white');

  const handleHomeClick = useCallback(() => {
    logClickHome();
    navigator.moveToHome();
  }, [logClickHome, navigator]);
  const handleSearchClick = useCallback(() => {
    logClickSearch();
    navigator.moveToSearch();
  }, [navigator, logClickSearch]);

  const handleCartClick = useCallback(() => {
    logClickCart();
  }, [logClickCart]);

  useStatusBarUpdate('white');

  return (
    <BottomDockedHeightProvider>
      <StackScreen
        hideBackButton={!showBackButton}
        onPressBack={onPressBack}
        backButtonTestID={'뒤로가기버튼'}
        rightIcons={[
          <HeaderIcon testID={'홈버튼'} onPress={handleHomeClick}>
            <NaviIconHome />
          </HeaderIcon>,
          <HeaderIcon testID={'검색버튼'} onPress={handleSearchClick}>
            <NaviIconSearch />
          </HeaderIcon>,
          <CartIcon onPressCart={handleCartClick} />,
        ]}
      >
        <GoodsDetailContents />
      </StackScreen>
    </BottomDockedHeightProvider>
  );
};

export default GoodsDetailPage;
